import React from "react";
import { Link } from "react-router-dom";
import defaultImage from "../../assests/defaultImage.png";
import { BoxLoader } from "../SkeletonLoaders";

// Shared card shell for every "person" grid in the Friends feature
// (Suggested Accounts, Friend Requests, My Friends). Passing `user={null}`
// renders a skeleton that fills the exact same shape as the loaded card, so
// loading never causes a layout jump.
const UserCard = ({ user, meta, renderActions, linkToProfile = true }) => {
  const loading = !user;
  const { firstName, lastName, profilePhoto, userId } = user ?? {};
  const avatar = profilePhoto?.length > 0 ? profilePhoto[0]?.photoPublicUrl : defaultImage;
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();

  const Avatar = (
    <div className="w-16 aspect-square rounded-full border border-customGray overflow-hidden relative flex-shrink-0">
      {loading ? (
        <div className="w-full h-full">
          <BoxLoader />
        </div>
      ) : (
        <img src={avatar} alt={fullName} className="rounded-full w-full h-full object-cover" />
      )}
    </div>
  );

  const NameBlock = (
    <div className="flex w-full flex-col min-w-0">
      {loading ? (
        <div className="w-full h-3 rounded overflow-hidden">
          <BoxLoader />
        </div>
      ) : (
        <>
          <h2 title={fullName} className="text-[12px] line-clamp-2 font-semibold">
            {fullName}
          </h2>
          {meta}
        </>
      )}
    </div>
  );

  return (
    <div className="bg-customDark text-white rounded-lg shadow-md p-4 flex flex-col items-center">
      <div className="flex items-center gap-2 w-full">
        {linkToProfile && !loading ? (
          <Link to={`/user/${userId}`} className="flex items-center gap-2 w-full min-w-0 no-underline text-inherit">
            {Avatar}
            {NameBlock}
          </Link>
        ) : (
          <>
            {Avatar}
            {NameBlock}
          </>
        )}
      </div>

      <div className="mt-4 w-full">
        {loading ? (
          <div className="w-full h-10 rounded overflow-hidden">
            <BoxLoader />
          </div>
        ) : (
          renderActions?.(user)
        )}
      </div>
    </div>
  );
};

export default UserCard;
